export default __webpack_public_path__ + "static/media/GQ.db9e48ad.svg";